import { Stack, Typography } from '@mui/material';
import { DateTimePickerTabsProps } from '@mui/x-date-pickers';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CalendarIcon } from '@/shared/assets/icons/calendar-icon';
import { ClockIcon } from '@/shared/assets/icons/clock-icon';
import { StyledDatePickerTabs } from '@/shared/components/ui/form/components/form-date-time-picker/components/form-date-time-picker-tabs/form-date-time-picker-tabs.styled';

export const FormDateTimePickerTabs: React.FC<DateTimePickerTabsProps> = ({
  dateIcon,
  timeIcon,
  ...props
}) => {
  const { t } = useTranslation();

  const customDateIcon = () => {
    return (
      <Stack direction="row" alignItems="center" gap="0.5rem">
        {dateIcon ?? <CalendarIcon />}
        <Typography variant="p7">{t('common:date')}</Typography>
      </Stack>
    );
  };

  const customTimeIcon = () => {
    return (
      <Stack direction="row" alignItems="center" gap="0.5rem">
        {timeIcon ?? <ClockIcon />}
        <Typography variant="p7">{t('common:time_hours')}</Typography>
      </Stack>
    );
  };

  return (
    <StyledDatePickerTabs
      {...props}
      dateIcon={customDateIcon()}
      timeIcon={customTimeIcon()}
    />
  );
};
